import React from 'react';
import './Home.scss';

const Home = () => {
    return (
        <section className="home" id="home">

            <div className="container">

                <h3>your content goes here</h3>

                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum quae ut nesciunt quos at quisquam aperiam tenetur, nihil expedita modi voluptate magnam eligendi. Libero numquam aliquam earum natus maiores eum?</p>

                <a href="#services" className="btn">discover</a>

            </div>


        </section>
    )
}

export default Home